<template>
  <ModalDialog
    ref="dialog"
    title="Offcut Split"
    icon="fa-scalpel-path"
    :showFooter="true"
    closeTitle="Cancel"
    submitTitle="Split"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="form" :labelColumnSize="3">

      <FormRow label="Split Direction">
        <FormSelect :options="OptimiserNodeSplitDirTypeLookup" v-model="splitDirectionType" />
      </FormRow>
      <FormRow :label="distanceLabelTitle">
        <FormInputText type="number" addon="mm" v-model="distance" />
      </FormRow>
      
    </FormGroup>
  </ModalDialog>
</template>

<style scoped>

</style>

<script>
import _ from 'lodash'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

import { OptimiserNodeSplitDirTypes, OptimiserNodeSplitDirTypeLookup } from '@/store/types'

export default {
  name: 'OptimiserOffcutSplitDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
  },
  data() {
    return {
      form: {},
      offcutAllocation: {},
      splitDirectionType: null,
      distance: 0
    }
  },
  watch: {
    splitDirectionType: function() {
      // Default distance to middle of offcut
      if(this.splitDirectionType == OptimiserNodeSplitDirTypes.vertical) {
        this.distance = Math.round(this.offcutAllocation.width / 2)
      } else {
        this.distance = Math.round(this.offcutAllocation.height / 2)
      }
    }
  },
  created() {
    this.OptimiserNodeSplitDirTypeLookup = OptimiserNodeSplitDirTypeLookup
  },
  mounted() {
  },
  computed: {
    distanceLabelTitle() {
      if(this.splitDirectionType == OptimiserNodeSplitDirTypes.vertical)
        return 'Distance from Left'
      return 'Distance from Top'
    }
  },
  methods: {
    show(params) {
      this.form = {}

      this.offcutAllocation = _.cloneDeep(params)

      // Calculate split direction based on longest axis
      if(this.offcutAllocation.width > this.offcutAllocation.height) {
        this.splitDirectionType = OptimiserNodeSplitDirTypes.vertical
      } else {
        this.splitDirectionType = OptimiserNodeSplitDirTypes.horizontal
      }

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.form = this.clearFormResponse()

      this.distance = parseInt(this.distance)

      // Check distance in within offcut
      if(this.splitDirectionType == OptimiserNodeSplitDirTypes.vertical) {
        if(this.distance <= 0 || this.distance >= this.offcutAllocation.width) {
          this.form.errorMessage = 'Split position is outside of offcut'
          return
        }
      } else {
        if(this.distance <= 0 || this.distance >= this.offcutAllocation.height) {
          this.form.errorMessage = 'Split position is outside of offcut'
          return
        }
      }

      this.modalClosed({ directionType: this.splitDirectionType, distance: this.distance })
      this.hide()
    },
  }
}
</script>